import React from 'react';
import { X } from 'lucide-react';

const EulaDrawer = ({ isOpen, onClose, content, loading }) => {
  if (!isOpen) return null;

  return (
    <div style={overlay} onClick={onClose}>
      <div style={drawer} onClick={e => e.stopPropagation()}>
        <div style={header}>
          <h2 style={{ margin: 0, color: '#fff', fontSize: '1.1rem' }}>EULA — Política de privacidad</h2>
          <button style={closeBtn} onClick={onClose}><X size={20} /></button>
        </div>
        <div style={body}>
          {loading ? (
            <p style={{ color: 'rgba(255,255,255,0.5)' }}>Cargando...</p>
          ) : content ? (
            <div dangerouslySetInnerHTML={{ __html: content }} />
          ) : (
            <p style={{ color: 'rgba(255,255,255,0.5)' }}>No se pudo cargar el contenido.</p>
          )}
        </div>
      </div>
    </div>
  );
};

const overlay = {
  position: 'fixed', inset: 0,
  background: 'rgba(0,0,0,0.6)',
  zIndex: 2000,
  display: 'flex', justifyContent: 'flex-end',
};

const drawer = {
  width: '480px', maxWidth: '100vw',
  height: '100vh',
  background: '#1a1a1f',
  borderLeft: '1px solid rgba(255,255,255,0.08)',
  display: 'flex', flexDirection: 'column',
};

const header = {
  display: 'flex', justifyContent: 'space-between', alignItems: 'center',
  padding: '20px 24px',
  borderBottom: '1px solid rgba(255,255,255,0.08)',
};

const body = {
  flex: 1, overflowY: 'auto',
  padding: '24px',
  color: 'rgba(255,255,255,0.8)',
  fontSize: '0.9rem', lineHeight: 1.7,
};

const closeBtn = {
  background: 'transparent', border: 'none',
  color: 'rgba(255,255,255,0.6)', cursor: 'pointer',
  display: 'flex', alignItems: 'center',
};

export default EulaDrawer;
